import React from 'react'
import {
  Container,
} from 'semantic-ui-react'

const ScreenContainer = ({mode, children}) => (
  <div style={{ marginTop: '7em' }}>
    {
      mode==='compare'
      ?
      <div>{children}</div>
      :
      <Container text>
        <div>{children}</div>
      </Container>
    }
  </div>
);

export default ScreenContainer